import ChevronDownIcon from "@atlaskit/icon/core/chevron-down";
import ChevronUpIcon from "@atlaskit/icon/core/chevron-up";
import {createElement, useState, type ReactNode} from "react";
import {AnankeTempVerticalSpacer} from "~/components/anankeTemp/anankeTempVerticalSpacer";
import type {IconProp} from "@atlaskit/button/dist/types/entry-points/new";
import {AnankeText} from "@vesta/ananke/components/anankeText";
import type {NewIconProps} from "@atlaskit/icon/dist/types/types";

export function AnankeTempCollapsibleSectionWithIcon({
    title,
    icon,
    iconColor,
    iconBackgroundColor,
    children,
    className,
    initialIsOpen,
    headerTrailing,
}: {
    title: string;
    icon: IconProp;
    iconColor: NewIconProps["color"];
    iconBackgroundColor: string;
    children: ReactNode;
    className?: string;
    initialIsOpen?: boolean;
    /** Rendered before the chevron; clicks do not toggle the section. */
    headerTrailing?: ReactNode;
}) {
    const [isOpen, setIsOpen] = useState(() => initialIsOpen ?? true);

    return (
        <div className={className}>
            <div
                className="w-full flex items-center justify-between cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="flex items-center gap-x-ds-space-100">
                    <div
                        className="flex items-center justify-center w-8 h-8 rounded"
                        style={{
                            backgroundColor: iconBackgroundColor
                        }}
                    >
                        {createElement(icon, {label: "", ...({color: iconColor})})}
                    </div>
                    <AnankeText size="large" weight="medium">
                        {title}
                    </AnankeText>
                </div>

                <div className="flex items-center gap-x-ds-space-100">
                    {headerTrailing !== undefined ? (
                        <div
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                        >
                            {headerTrailing}
                        </div>
                    ) : null}
                    {createElement(isOpen ? ChevronUpIcon : ChevronDownIcon, {
                        label: "",
                    })}
                </div>
            </div>

            {isOpen === false ? null : (
                <>
                    <AnankeTempVerticalSpacer above="collapsibleSectionStart" below="formRow" />
                    {children}
                </>
            )}
        </div>
    );
}
